<template>
    <div>
        {{ isShow ? checkIdcard : idcard }}
        <i class="iconfont icon-yanjing-biyan" @click="checkShow(true)" v-if="!isShow && !isPdf"></i>
        <i class="iconfont icon-yanjing" @click="checkShow(false)" v-if="isShow && !isPdf"></i>
    </div>
</template>

<script>
/**
 * 对身份证
 */
 import { AssessApi } from '../config/apis.js';
export default {
    props: ['idcard', 'guid'],
    data() {
        return {
            checkIdcard: '',
            isShow: false,
            isPdf: false
        }
    },
    watch: {

    },
    mounted() {
        if (location.hash.indexOf('pdf') > -1) {
            this.isPdf = true
        }
    },
    methods: {
        checkShow(show) {
            if (this.checkIdcard) {
                this.isShow = show;
                return
            }
            let apiUrl = AssessApi.getPsychometricsPrivacy;
            let post = {
                candId: this.getUrlParam('candId'),
                    positionId: this.getUrlParam('positionId'),
                privacyDataName: 'idcard',
                userType: 1
            }
            this.$axios.post(apiUrl, post).then((res) => {
                if (res.data.code == 0) {
                    this.checkIdcard =  res.data.data.privacyData;
                    this.isShow = show;
                }
            }).catch((res) => { })
        },
        //获取url的🔧
        getUrlParam(name) {
            var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); //构造一个含有目标参数的正则表达式对象
            var r = window.location.search.substr(1).match(reg); //匹配目标参数
            if (r != null) return unescape(r[2]);
            return null; //返回参数值
        }
    }
}
</script>

<style lang="scss" scoped>

.iconfont {
    margin-left: 10px;
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/report/components/idcard-model.vue